//#region Components
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/v2";
//#endregion

const DialogAlertConfirmDesactivation = ({
    dialog, actions
}) => {
    return (
        <DialogAlertAction
            dialog={dialog}
            close={actions.cancel}
            widthContent="100%"
            variant="secondary"
            title="¿Deseas desactivar el espacio?"
            content="Recuerda que solo lo podrás hacer si no existen reservas asignadas.">
            <CustomButton
                variant="secondary"
                width="130px"
                text="No, cancelar"
                onClick={actions.cancel}/>
            <CustomButton
                width="130px"
                text="Si, desactivar"
                onClick={actions.confirm}/>
        </DialogAlertAction>
    );
}

export default DialogAlertConfirmDesactivation;